<template>
  <div class="d-flex flex-column flex-auto">
    <template v-if="hasTableData || loadingState">
      <InsightsUnusualActivityWidgetTable
        :limit="5"
        :loading="loadingState"
        :sort-options="sortOptions"
        :time-zone="timeZone"
        :open-dialog="openDialog"
        :widget-data="data"
        @sort="sort"
        @switch-member="switchMember"
      />
      <AppPagination
        v-if="isPaginationPresent"
        v-show="hasTableData"
        :pagination="pagination"
        :resource="paginationResource"
        @page-changed="setPage"
      />
    </template>
  </div>
</template>
<script>
import InsightsUnusualActivityWidgetTable from '~/components/insights/InsightsUnusualActivityWidgetTable.vue';
import { mapGetters } from 'vuex';
import { InsightsFilters } from '~/mixins';
import { isEmpty } from 'lodash-es';

export default {
  name: 'InsightsUnusualActivityWidgetTableWrapper',
  components: {
    InsightsUnusualActivityWidgetTable,
  },
  mixins: [InsightsFilters],
  props: {
    hasTableData: {
      type: Boolean,
      required: true,
    },
    emptyReason: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    sort: {
      type: Function,
      required: true,
    },
    openDialog: {
      type: Function,
      required: true,
    },
    switchMember: {
      type: Function,
      required: true,
    },
    timeZone: {
      type: String,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    setPage: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isUserDashboard', 'isIndividualTeamDashboard', 'currentDashboardUser']),
    loadingState() {
      return this.isLoading || (this.isUserDashboard && !this.currentDashboardUser);
    },
    paginationResource() {
      return { one: 'member', many: 'members' };
    },
    isPaginationPresent() {
      return !isEmpty(this.pagination);
    },
  },
};
</script>
